import axios from 'axios';

let sessionEndedNotified = false;

export const apiCall = (apiRequest) => {
  console.log("apiCall",apiRequest)
  return new Promise((resolve, reject) => {
    axios({
      method: apiRequest.method,
      url: apiRequest.url,
      headers: apiRequest.headers,
      data: apiRequest.data || {},
      // timeout: 70000,
    })
      .then(async (response) => {
        console.log("resp",response)
        resolve(response);
      })
      .catch(async (error) => {
        let response = error.response;
        console.log(error)
        if (response && response.status === 401) {
          console.log(error)
          // Tell the user why they are being sent to the login page (once, even
          // if several requests fail together), instead of logging out silently.
          if (!sessionEndedNotified) {
            sessionEndedNotified = true;
            alert("Your session is no longer valid. It may have expired, or this login was removed. Please log in again.");
          }
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          window.location.href = '/';
          window.location.reload();
        }
        reject(error);
      });
  });
};